import React, { FunctionComponent, useEffect, useRef } from 'react'

const PublicationStrollToTop: FunctionComponent = () => {
  const scrollToTopRef = useRef<HTMLDivElement>(null)

  const scrollToTop = () => {
    const scrollDistance = window.scrollY
    const scrollToTopDiv = scrollToTopRef.current

    if (scrollToTopDiv) {
      if (scrollDistance > 100) {
        scrollToTopDiv.classList.remove('d-none')
      } else {
        scrollToTopDiv.classList.add('d-none')
      }
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', scrollToTop)
    return () => window.removeEventListener('scroll', scrollToTop)
  }, [])

  return (
    <div className="scroll-to-top d-none" ref={scrollToTopRef}>
      <a className="js-scroll-trigger" href="#" aria-label="Tillbaka till toppen">
        <span className="fa fa-chevron-up" aria-hidden="true" />
      </a>
    </div>
  )
}

export default PublicationStrollToTop
